import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompaniesProvider, PersonsProvider } from '@modeso/aumico-lib-companies-fe';
import { GetOrganizationDto, GetUserDto, OrganizationProvider } from '@modeso/aumico-lib-users-fe';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import cloneDeep from 'lodash/cloneDeep';
import { combineLatest, filter, map, mergeMap, switchMap, tap, timer } from 'rxjs';
import { UpdateTaskDto } from '../../../../../../aumico-lib-cpmm-fe/src/lib/dtos/update-task-dto.interface';
import { TaskMetaInformationTableValue } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/task-meta-information-table-value.interface';
import { TaskMetaInformation } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/task-meta-information.interface';
import { TasksFilter } from '../../../../../../aumico-lib-cpmm-fe/src/lib/interfaces/tasks-filter.interface';

import { FormBuilder } from '@angular/forms';
import {
    AnnualReportMetaInformationDTO,
    AnnualReportNavigationProvider,
    AnnualReportProvider,
    CreateAnnualReportResponseDto,
    getNextBalanceSheetDateForCompanyById,
    onCreateAnnualReportSuccessfully,
} from '@modeso/aumico-lib-annualreport-fe';
import { AumGlobalAction, IAumGlobalActionEvent, ReportType } from '@modeso/aumico-lib-core-fe';
import { CPMMState } from '@modeso/aumico-lib-users-fe/enums/cpmm-state.enum';
import {
    AnnualReportStep,
    ISetupData,
    WorkflowConfigurationSelectionEnum,
} from '@modeso/types__aumico-lib-annualreport-be';
import { ICompanyDTO, ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { ofType } from '@ngrx/effects';
import { I18NextService } from 'angular-i18next';
import debug from 'debug';
import { Moment } from 'moment';
import { MixpanelService } from 'projects/mixpanel/mixpanel.service';
import { MIXPANEL_EVENTS } from 'projects/mixpanel/mixpanelEvents.enum';
import { ITasksExportTableHeaders } from '../../../../../../aumico-lib-annualreport-fe/src/lib/dtos/tasks-export-table-headers.dto';
import { WorkflowDocumentsProvider } from '../../../../../../aumico-lib-annualreport-fe/src/lib/provider/workflow-documets.provider';
import { ExportTasksFilterState, ExportTasksSectionExcelData } from '../../../../../../aumico-lib-cpmm-fe/src/lib';
import { TasksOverviewActions } from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/tasks.actions';
import { setScrollToTextState, setTasksFilter } from '../../../../../../aumico-lib-cpmm-fe/src/lib/actions/ui.actions';
import { SortDirection } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/sort-direction.enum';
import { TaskSortingProperties } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/task-sorting-properties.enum';
import { TaskState } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/task-state.enum';
import { WorkflowArea } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/workflow-area.enum';
import {
    selectAllTasks,
    TasksOverviewState,
} from '../../../../../../aumico-lib-cpmm-fe/src/lib/reducers/tasks.reducer';
import { selectTasksFilter } from '../../../../../../aumico-lib-cpmm-fe/src/lib/reducers/ui.reducer';
import { ProjectsOverviewActions, selectProjectsOverview } from '../../../../../../aumico-lib-projects-fe/src/lib';
import { AssigneeFilter } from '../../../enums/assigneeFilter.enum';
import { Paths } from '../../../enums/paths.enum';
import { AnnualReportOrchestrator } from '../../../orchestrator/annualreport.orchestrator';
import { BasePageComponent } from '../../../pages/base.page';
import { ResetStoreService } from '../../../shared/services/resetStore.service';

import { SubjectType } from '../../../../../../aumico-lib-cpmm-fe/src/lib/enums/subject-type.enum';
@UntilDestroy()
@Component({
    selector: 'tasks-overview.page',
    templateUrl: './tasks-overview.page.html',
    styleUrls: ['./tasks-overview.page.scss'],
})
export class TasksOverviewPage extends BasePageComponent implements OnInit {
    tasksOverviewTableData: TaskMetaInformationTableValue[] = [];

    tasksFilter: TasksFilter | undefined;

    assigneeOptions: INameId[] = [];
    searchedAssigneeOptions: INameId[] = [];

    companies: {
        id: string;
        name: string;
    }[] = [];

    private projectMetaMap = new Map<string, string>(); // projectId -> annualReportMetaDataId

    // REV-22155 — filter "Mandant": companies and persons; persons are told apart by id.
    private personOptions: { id: string; name: string }[] = [];
    private personIds = new Set<string>();

    searchedCompaniesOptions: {
        id: string;
        name: string;
    }[] = [];

    annualReportsMetaInformationRecords: AnnualReportMetaInformationDTO[] = [];

    public isCpmmActive: boolean = false;
    public isMandateAndTaskManagementEnabled: boolean = false;
    public companiesList: ICompanyNameIdLegalFormDTO[] = [];
    public balanceSheetDate: Date | undefined;
    public mandateManagementWorkflow: WorkflowConfigurationSelectionEnum;
    public closingWorkflow: WorkflowConfigurationSelectionEnum;
    public showCreateProjectPopup = false;
    private selectedCompanyDto: ICompanyDTO | undefined;
    private reportType: ReportType | undefined;
    isCreatingAnnualReport: boolean;
    activeProjectId: string;
    private shouldNavigateToEditPage = false;

    // Varaibles for bulk edit
    bulkActions = [
        { id: 'STATUS_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_status_action_bar' },
        { id: 'ASSIGNEE_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_assignee_action_bar' },
        { id: 'DUE_DATE_CHANGE', translationKey: 'aumico_tasks_overview_bulk_edit_due_date_action_bar' },
    ];
    deleteAction = { id: 'DELETE_TASKS', translationKey: 'aumico_tasks_overview_bulk_edit_delete_action_bar' };
    // All selected tasks for bulk actions (Single Source of Truth)
    selectedTasksForBulkActions: Set<string> = new Set<string>();
    selectAllToggled: boolean = false;

    // Track state for smart selection cleanup
    private isInitialLoad: boolean = true;
    openBulkEditStatus: boolean = false;
    openBulkEditAssignee: boolean = false;
    openBulkEditDueDate: boolean = false;
    openBulkDeleteConfirmationDialog: boolean = false;
    possibleStatus = [
        {
            id: TaskState.OPEN,
            name: this.localizedTexts.t('aumico_pm_tasks_status_open') as string,
        },
        {
            id: TaskState.IN_PROGRESS,
            name: this.localizedTexts.t('aumico_pm_tasks_status_in_progress') as string,
        },
        {
            id: TaskState.IN_REVIEW,
            name: this.localizedTexts.t('aumico_pm_tasks_status_in_review') as string,
        },
        {
            id: TaskState.DONE,
            name: this.localizedTexts.t('aumico_pm_tasks_status_done') as string,
        },
    ];
    bulkEditStatusControl = this.fb.control(null);
    bulkEditAssigneeControl = this.fb.control(null);
    bulkEditDueDateControl = this.fb.control(null);
    currentOrganization: GetOrganizationDto;

    constructor(
        private store: Store<TasksOverviewState>,
        private injector: Injector,
        private readonly organizationProvider: OrganizationProvider,
        private readonly companiesProvider: CompaniesProvider,
        private readonly localizedTexts: I18NextService,
        private readonly resetStoreService: ResetStoreService,
        private readonly annualReportProvider: AnnualReportProvider,
        private readonly mixpanelService: MixpanelService,
        private readonly orchestratorOfAnnualReport: AnnualReportOrchestrator,
        protected override router: Router,
        private readonly annualReportNavigationProvider: AnnualReportNavigationProvider,
        private workflowDocumentsProvider: WorkflowDocumentsProvider,
        private fb: FormBuilder,
        private readonly personsProvider: PersonsProvider,
    ) {
        super(injector);

        this.resetStoreService.resetTasks();

        this.organizationProvider.dispatchGetUsers(true);

        this.companiesProvider.dispatchCompaniesNameIdLegalFormList();

        this.companiesProvider.getCompaniesNameIdLegalForm$().subscribe((companies) => {
            this.companiesList = companies;

            this.companies = companies.map((company) => ({
                id: company._id,
                name: company.name,
            }));
            this.searchedCompaniesOptions = this.mandantOptions();
        });

        this.personsProvider.dispatchPersonsList();
        this.personsProvider.getPersons$().subscribe((persons) => {
            this.personOptions = persons.map((p) => ({ id: p._id!, name: `${p.lastName} ${p.firstName}` }));
            this.personIds = new Set(this.personOptions.map((p) => p.id));
            this.searchedCompaniesOptions = this.mandantOptions();
        });
    }

    /** REV-22155 — companies and persons, sorted by name. */
    private mandantOptions(): { id: string; name: string }[] {
        return [...this.companies, ...this.personOptions].sort((a, b) => a.name.localeCompare(b.name));
    }

    /** Selected "Mandant" ids for the dropdown: companies and persons together. */
    get selectedMandantIds(): string[] {
        return [...(this.tasksFilter?.companyIds ?? []), ...(this.tasksFilter?.personIds ?? [])];
    }

    /** REV-22155 — filter "Typ" (Firma / Person). */
    onSubjectTypeFilterChange(subjectTypes: SubjectType[]): void {
        this.tasksFilter = { ...this.tasksFilter, subjectTypes: subjectTypes.length ? subjectTypes : undefined };
        this.store.dispatch(setTasksFilter({ filter: this.tasksFilter }));
        this.refetchTasks();
    }

    override ngOnInit(): void {
        super.ngOnInit();

        combineLatest([
            this.store.select(selectAllTasks),
            this.activeUserAumicoInternalId$.pipe(filter((id) => id != null)),
        ])
            .pipe(
                untilDestroyed(this),
                switchMap(([tasks, activeUserId]) =>
                    combineLatest([
                        this.organizationProvider.getUsers(),
                        this.organizationProvider.getPossibleAssignees(),
                    ]).pipe(
                        filter(([allUsers, activeUsers]) => allUsers.length > 0), // wait until users are loaded
                        map(([allUsers, activeUsers]) => {
                            // Create a userMap with ALL users (including deleted) for display purposes
                            const userMap = new Map<string, GetUserDto>();
                            allUsers.forEach((user) => userMap.set(user.id, user));

                            // Build assigneeOptions using only ACTIVE users for dropdowns
                            this.assigneeOptions = [];

                            const userOptions = activeUsers.map((user) => ({
                                id: user.id,
                                name: user.firstName + ' ' + user.lastName,
                                isMe: user.isMe,
                            }));

                            userOptions.unshift({
                                id: AssigneeFilter.unassigned,
                                name: this.localizedTexts.t('aumico_tasks_unassigned') as string,
                                isMe: false,
                            });

                            // Add current user to the top of the list
                            const index = userOptions.findIndex((user) => user.isMe === true);
                            if (index > -1) {
                                const [item] = userOptions.splice(index, 1); // Remove the item
                                userOptions.unshift(item); // Add it to the beginning
                            }

                            this.assigneeOptions.push(...userOptions); // Add user options to the list
                            this.searchedAssigneeOptions = cloneDeep(this.assigneeOptions);

                            // Map flat tasks using the full userMap (includes deleted users)
                            const updated = cloneDeep(
                                tasks.map((task) => {
                                    const assignedUser = task.assignedTo ? userMap.get(task.assignedTo) : null;
                                    return {
                                        ...task,
                                        assignedTo: assignedUser
                                            ? assignedUser.firstName + ' ' + assignedUser.lastName
                                            : (this.localizedTexts.t('aumico_tasks_unassigned') as string),
                                        assigneeDeleted: assignedUser?.isDeleted || false,
                                    } as TaskMetaInformationTableValue;
                                }),
                            );

                            return updated;
                        }),
                    ),
                ),
            )
            .subscribe((transformedTasks) => {
                // Update the data
                this.tasksOverviewTableData = cloneDeep(transformedTasks);

                // Smart cleanup: Remove selections for tasks no longer visible
                if (!this.isInitialLoad && this.selectedTasksForBulkActions.size > 0) {
                    this.cleanupInvalidSelections();
                }

                this.isInitialLoad = false;
            });

        this.store
            .select(selectTasksFilter())
            .pipe(untilDestroyed(this))
            .subscribe((tasksFilter) => {
                this.tasksFilter = cloneDeep(tasksFilter);
            });

        this.store
            .select(selectProjectsOverview)
            .pipe(untilDestroyed(this))
            .subscribe((projects) => {
                this.projectMetaMap.clear();
                projects.forEach((project) => {
                    this.projectMetaMap.set(project.projectId, project.annualReportMetaData);
                });
            });

        this.store.dispatch(TasksOverviewActions.loadTasksOverview({ filter: this.tasksFilter }));

        this.annualReportProvider
            .getAnnualReports$()
            .pipe(untilDestroyed(this))
            .subscribe((annualReportsMetaInformationRecords) => {
                this.annualReportsMetaInformationRecords = cloneDeep<AnnualReportMetaInformationDTO[]>(
                    annualReportsMetaInformationRecords,
                );
            });

        // Used for the project-wizard in empty state
        // TODO
        this.annualReportProvider
            .getActiveAnnualReport$()
            .pipe(
                filter((annualReport) => annualReport != null),
                mergeMap((annualReport) =>
                    this.annualReportProvider
                        .getActiveMetaInformation$()
                        .pipe(map((metaInformation) => ({ annualReport, metaInformation }))),
                ),
                // getActiveMetaInformation$() is not null-filtered (unlike annualReport above): the
                // active report can be set before its meta-information entity is in the store, so the
                // stream may emit an undefined metaInformation. Wait for it before deciding the route,
                // otherwise metaInformation.setupData below throws (Sentry REPORTS-FE-22 / REV-21422).
                filter(({ metaInformation }) => metaInformation != null),
                untilDestroyed(this),
            )
            .subscribe(({ annualReport, metaInformation }) => {
                const urlParts = this.router.url.split('/');
                urlParts.pop();
                urlParts.pop();
                urlParts.push(Paths.PROJECT);
                const newUrl = urlParts.join('/');

                const isInterimReport =
                    metaInformation.setupData?.reportType === ReportType.QUARTERLY ||
                    metaInformation.setupData?.reportType === ReportType.MONTHLY ||
                    metaInformation.setupData?.reportType === ReportType.CUSTOM;

                // Navigate to edit page - activeProjectId should now be properly set
                if (
                    this.shouldNavigateToEditPage &&
                    !(metaInformation && metaInformation.isSealed) &&
                    (!this.isCpmmActive || !this.isMandateAndTaskManagementEnabled || isInterimReport)
                ) {
                    this.router.navigateByUrl(`${newUrl}/${this.activeProjectId}`);
                } else if (
                    this.shouldNavigateToEditPage &&
                    !(metaInformation && metaInformation.isSealed) &&
                    this.isCpmmActive &&
                    this.isMandateAndTaskManagementEnabled &&
                    !isInterimReport
                ) {
                    this.router.navigateByUrl(`${newUrl}/${this.activeProjectId}/cpmm`);
                } else if (this.shouldNavigateToEditPage && metaInformation.isSealed) {
                    this.annualReportNavigationProvider.setActiveArNavigation([AnnualReportStep.PRINT], true);
                    this.router.navigateByUrl(`${newUrl}/${this.activeProjectId}/cpmm/report/${Paths.PRINT}`);
                }
            });
        // Used for the project-wizard in empty state
        this.actionsListener$
            .pipe(
                ofType(onCreateAnnualReportSuccessfully),
                mergeMap((action: { payload: CreateAnnualReportResponseDto }) =>
                    timer(1000).pipe(
                        map(() => action.payload),
                        switchMap((payload) =>
                            timer(500).pipe(
                                tap(() => {
                                    this.store.dispatch(
                                        ProjectsOverviewActions.setActiveProjectId({
                                            projectId: payload.projectId,
                                        }),
                                    );
                                    this.activeProjectId = payload.projectId;
                                }),
                                map(() => payload),
                            ),
                        ),
                    ),
                ),
                tap(() => (this.isCreatingAnnualReport = false)),
                mergeMap((payload: CreateAnnualReportResponseDto) => {
                    this.annualReportProvider.setActiveAnnualReportEncryptedId(payload.annualReportEncryptedId);
                    return this.annualReportProvider.getActiveAnnualReportEncryptedId$();
                }),
                untilDestroyed(this),
            )
            .subscribe((encryptedId) => {
                this.shouldNavigateToEditPage = true;
                this.orchestratorOfAnnualReport.load(encryptedId);
            });
        // Used for the project-wizard in empty state
        this.organizationProvider
            .getCurrentOrganization$()
            .pipe(
                filter((organization) => organization != null),
                untilDestroyed(this),
            )
            .subscribe((organization: GetOrganizationDto) => {
                // Used for task export to have org data
                this.currentOrganization = cloneDeep<GetOrganizationDto>(organization);
                this.isCpmmActive = organization.cpmmActivationDetails?.activationState === CPMMState.ACTIVE;
                this.isMandateAndTaskManagementEnabled = organization.isMandateAndTaskManagementEnabled ?? false;
            });
        // Used for the project-wizard in empty state
        this.actionsListener$
            .pipe(
                ofType(getNextBalanceSheetDateForCompanyById.getNextBalanceSheetDateForCompanyByIdSuccess),
                filter((payload) => payload?.payload != null),
                untilDestroyed(this),
            )
            .subscribe((payload) => {
                const dateString = payload.payload; // This is a string

                // Parse the date string as UTC to extract year, month, day without timezone interference
                const utcDate = new Date(dateString);
                this.balanceSheetDate = new Date(
                    Date.UTC(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), 0, 0, 0, 0),
                );
            });
        // Used for the project-wizard
        this.companiesProvider
            .getSelectedCompanyById$()
            .pipe(
                filter((company) => company != null),
                untilDestroyed(this),
            )
            .subscribe((company) => {
                this.selectedCompanyDto = cloneDeep<ICompanyDTO>(company);
            });
    }

    updateTask(updateEvent: { taskId: string; updateTaskDto: UpdateTaskDto }): void {
        this.store.dispatch(
            TasksOverviewActions.updateTask({ taskId: updateEvent.taskId, updateTaskDto: updateEvent.updateTaskDto }),
        );
    }

    sortTasks(sortEvent: { sortBy: TaskSortingProperties | null; sortOrder: SortDirection | null }): void {
        if (sortEvent.sortBy === null || sortEvent.sortOrder === null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                sortBy: undefined,
                sortOrder: undefined,
            };
            this.store.dispatch(setTasksFilter({ filter: this.tasksFilter }));
        } else {
            this.buildTasksFilter(undefined, undefined, undefined, undefined, undefined, undefined, sortEvent.sortOrder, sortEvent.sortBy);
        }
        this.refetchTasks();
    }

    onDueDateFilterChangeMulti(ranges: Array<{ startDate: Date | null; endDate: Date | null }>): void {
        this.buildTasksFilter(ranges);
        this.refetchTasks();
    }

    onAssigneeFilterChange(userIds: string[]): void {
        this.buildTasksFilter(undefined, userIds);
        this.refetchTasks();
    }

    onSearchFilterChangeAssignee(searchTerm: string): void {
        if (searchTerm === '' || searchTerm === null) {
            this.searchedAssigneeOptions = this.assigneeOptions;
            return;
        }
        this.searchedAssigneeOptions = this.assigneeOptions.filter((assignee) =>
            assignee.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );
    }

    onTaskStateFilterChange(taskStates: TaskState[]): void {
        this.buildTasksFilter(undefined, undefined, taskStates);
        this.refetchTasks();
    }

    /** REV-22155 — "Mandant": the ids are split into companies and persons. */
    onCompanyFilterChange(mandantIds: string[]): void {
        const personIds = mandantIds.filter((id) => this.personIds.has(id));
        this.tasksFilter = { ...this.tasksFilter, personIds: personIds.length ? personIds : undefined };
        this.buildTasksFilter(
            undefined,
            undefined,
            undefined,
            mandantIds.filter((id) => !this.personIds.has(id)),
        );
        this.refetchTasks();
    }

    onSearchFilterChange(searchTerm: string): void {
        if (searchTerm === null) {
            searchTerm = '';
        }
        this.buildTasksFilter(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, searchTerm);
        this.refetchTasks();
    }

    refetchTasks(): void {
        this.store.dispatch(TasksOverviewActions.loadTasksOverview({ filter: this.tasksFilter }));
    }

    private buildTasksFilter(
        dateRange?: Array<{ startDate: Date | null; endDate: Date | null }> | null,
        assignedTo?: string[] | undefined,
        taskStates?: TaskState[],
        companyIds?: string[],
        _unused1?: unknown,
        _unused2?: unknown,
        sortOrder?: SortDirection,
        sortBy?: TaskSortingProperties,
        searchTerm?: string,
    ): void {
        if (dateRange !== undefined) {
            const normalized = (dateRange || [])
                .filter((range) => range.startDate || range.endDate)
                .map((range) => ({
                    startDate: range.startDate ? range.startDate.toISOString() : null,
                    endDate: range.endDate ? range.endDate.toISOString() : null,
                }));

            this.tasksFilter = {
                ...this.tasksFilter,
                dateRange: normalized.length > 0 ? normalized : undefined,
            };
        }

        if (assignedTo !== undefined) {
            this.tasksFilter = {
                ...this.tasksFilter,
                assignedTo: assignedTo,
            };
        }

        if (taskStates != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                taskStates: taskStates,
            };
        }

        if (companyIds != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                companyIds: companyIds,
            };
        }

        if (sortBy != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                sortBy: sortBy,
            };
        }

        if (sortOrder != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                sortOrder: sortOrder,
            };
        }

        if (searchTerm != null) {
            this.tasksFilter = {
                ...this.tasksFilter,
                taskName: searchTerm,
            };
        }

        this.store.dispatch(setTasksFilter({ filter: this.tasksFilter }));
    }

    onSearchFilterChangeCompanies(searchTerm: string) {
        if (searchTerm === '' || searchTerm === null) {
            this.searchedCompaniesOptions = this.mandantOptions();
            return;
        }
        this.searchedCompaniesOptions = this.mandantOptions().filter((company) =>
            company.name.toLowerCase().includes(searchTerm.toLowerCase()),
        );
    }
    addProject() {
        this.showCreateProjectPopup = true;
    }

    public onCompanySelected(company: ICompanyNameIdLegalFormDTO): void {
        this.companiesProvider.dispatchCompanyById(company._id);
    }

    public onReportTypeSelected(reportType: ReportType): void {
        this.reportType = reportType;
        if (this.selectedCompanyDto) {
            this.annualReportProvider.dispatchGetNextBalanceSheetDateForCompanyById(
                this.selectedCompanyDto._id,
                reportType,
            );
        }
    }

    public onBalanceSheetDateSelected(balanceSheetDate: Date): void {
        this.balanceSheetDate = balanceSheetDate;
    }

    public onMandateManagementWorkflowSelected(mandateManagementWorkflow: WorkflowConfigurationSelectionEnum): void {
        this.mandateManagementWorkflow = mandateManagementWorkflow;
    }

    public onClosingWorkflowSelected(closingWorkflow: WorkflowConfigurationSelectionEnum): void {
        this.closingWorkflow = closingWorkflow;
    }

    public closeNewProjectDialog(closeAndSave: boolean): void {
        this.showCreateProjectPopup = false;
        if (closeAndSave) {
            const setupData: ISetupData = {
                company: this.selectedCompanyDto,
                balanceSheetDate: this.balanceSheetDate.toISOString(),
                mandateManagementWorkflow: this.mandateManagementWorkflow,
                closingWorkflow: this.closingWorkflow,
                reportType: this.reportType ?? ReportType.ANNUAL,
                fxEnabled: this.selectedCompanyDto?.fx?.enabled === true,
            };

            this.createAnnualReport(setupData);
        }
    }

    public openCreateProjectDialog(): void {
        this.showCreateProjectPopup = true;
    }

    createAnnualReport(setupData: ISetupData): void {
        debug('create new annual report');
        this.mixpanelService.track(MIXPANEL_EVENTS.CREATE_ANNNUAL_REPORT_BUTTON_CLICK);
        this.orchestratorOfAnnualReport.new(setupData);

        const event: IAumGlobalActionEvent = {
            action: AumGlobalAction.UPDATECURRENTENTITY,
            value: 'New',
        };
        this.actionHeaderService.onAction(event);
        this.isCreatingAnnualReport = true;
    }
    public isAnyFilterActive(): boolean {
        return !!(
            this.tasksFilter.dateRange?.length ||
            this.tasksFilter.assignedTo ||
            this.tasksFilter.taskStates?.length ||
            this.tasksFilter.taskName ||
            this.tasksFilter.sectionName ||
            this.tasksFilter.companyIds?.length ||
            this.tasksFilter.personIds?.length ||
            this.tasksFilter.subjectTypes?.length
        );
    }

    onTaskClicked(selection: { projectId: string; area: WorkflowArea; sectionName: string; subjectType?: SubjectType }): void {
        // REV-22155 — person task: straight to the person project's mandate management, no annual report.
        if (selection.subjectType === SubjectType.PERSON) {
            void this.router.navigate(
                [
                    `/${this.localStorageService.getCurrentLanguage()}/${Paths.HOME}/${Paths.PROJECT}`,
                    Paths.PERSON_PROJECTS,
                    selection.projectId,
                    Paths.MANDATE_MANAGEMENT,
                ],
                selection.sectionName ? { queryParams: { section: selection.sectionName } } : {},
            );
            return;
        }

        const annualReportMetaDataId = this.projectMetaMap.get(selection.projectId);

        if (!annualReportMetaDataId) {
            throw new Error('Annual report metadata id not found for project ' + selection.projectId);
        }

        const annualReportMeta = this.annualReportsMetaInformationRecords.find(
            (arMeta) => arMeta._id === annualReportMetaDataId,
        );

        if (annualReportMeta && annualReportMeta.annualReportEncryptedId) {
            this.annualReportProvider.setActiveAnnualReportEncryptedId(annualReportMeta.annualReportEncryptedId);
            this.orchestratorOfAnnualReport.load(annualReportMeta.annualReportEncryptedId);
        }

        this.shouldNavigateToEditPage = true;

        // We should not load the data here, instead it shall be loaded on the fs edit page
        // Here we should simply navigate to mandate management page
        this.store.dispatch(ProjectsOverviewActions.setActiveProjectId({ projectId: selection.projectId }));
        this.store.dispatch(
            ProjectsOverviewActions.fetchProjectDataByProjectId({
                projectId: selection.projectId,
            }),
        );

        if (selection.area && selection.area === WorkflowArea.MANDATE_MANAGEMENT && selection.sectionName) {
            this.store.dispatch(setScrollToTextState({ text: selection.sectionName }));
        }

        // Navigate to mandate management page
        const urlParts = this.router.url.split('/');
        urlParts.pop();
        urlParts.pop();
        const newUrl = urlParts.join('/');
        const backroute = this.router.url;

        if (selection.area === WorkflowArea.MANDATE_MANAGEMENT) {
            this.router.navigateByUrl(
                `${newUrl}/${Paths.PROJECT}/${selection.projectId}/cpmm/${Paths.MANDATE_MANAGEMENT
                }?backTarget=${encodeURIComponent(backroute)}`,
            );
            return;
        }
    }

    public exportTasksExcel(): void {
        if (this.tasksOverviewTableData.length === 0) {
            return;
        }

        const transformTask = (task: TaskMetaInformationTableValue) => {
            let dueDate: string;

            if (task.dueDate && task.dueDate instanceof Date) {
                const isoDate = task.dueDate.toISOString().split('T')[0];
                const [year, month, day] = isoDate.split('-');
                dueDate = `${day}.${month}.${year}`;
            } else if (task.dueDate && typeof task.dueDate === 'string') {
                const dateObj = new Date(task.dueDate);
                if (!isNaN(dateObj.getTime())) {
                    const isoDate = dateObj.toISOString().split('T')[0];
                    const [year, month, day] = isoDate.split('-');
                    dueDate = `${day}.${month}.${year}`;
                } else {
                    dueDate = task.dueDate as unknown as string;
                }
            } else {
                dueDate = '';
            }

            let taskState: string;
            switch (task.taskState) {
                case TaskState.OPEN:
                    taskState = this.localizedTexts.t('aumico_pm_tasks_status_open') as string;
                    break;
                case TaskState.DONE:
                    taskState = this.localizedTexts.t('aumico_pm_tasks_status_done') as string;
                    break;
                case TaskState.NOT_APPLICABLE:
                    taskState = this.localizedTexts.t('aumico_ui_not_applicable') as string;
                    break;
                case TaskState.IN_REVIEW:
                    taskState = this.localizedTexts.t('aumico_pm_tasks_status_in_review') as string;
                    break;
                case TaskState.IN_PROGRESS:
                    taskState = this.localizedTexts.t('aumico_pm_tasks_status_in_progress') as string;
                    break;
                default:
                    taskState = this.localizedTexts.t('aumico_pm_tasks_status_open') as string;
                    break;
            }

            return {
                task: {
                    ...task,
                    dueDate: dueDate as unknown as Date,
                    taskState: taskState as unknown as TaskState,
                },
            };
        };

        // Group flat tasks by projectId for the export format
        const projectGroups = new Map<string, { name: string; tasks: TaskMetaInformationTableValue[] }>();
        this.tasksOverviewTableData.forEach((task) => {
            if (!projectGroups.has(task.projectId)) {
                projectGroups.set(task.projectId, { name: task.companyName ?? task.personName ?? '', tasks: [] });
            }
            projectGroups.get(task.projectId)!.tasks.push(task);
        });

        const dataToExport: ExportTasksSectionExcelData[] = Array.from(projectGroups.entries()).map(
            ([projectId, group]) => ({
                id: projectId,
                name: group.name,
                tasks: group.tasks.map(transformTask),
            }),
        );

        const tableHeaders: ITasksExportTableHeaders = {
            description: this.localizedTexts.t('aumico_pm_tasks_task_table_header').toString(),
            assignedTo: this.localizedTexts.t('aumico_pm_tasks_responsible_table_header').toString(),
            dueDate: this.localizedTexts.t('aumico_pm_tasks_due_date_table_header').toString(),
            taskState: this.localizedTexts.t('aumico_pm_tasks_status_table_header').toString(),
            documents: this.localizedTexts.t('aumico_ui_documents').toString(),
            annotations: this.localizedTexts.t('aumico_ui_annotations').toString(),
            sectionName: this.localizedTexts.t('aumico_pm_tasks_section_table_header').toString(),
            companyName: this.localizedTexts.t('aumico_tasks_col_mandant').toString(),
        };

        const fullDate = new Date();
        const mm = String(fullDate.getMonth() + 1).padStart(2, '0');
        const dd = String(fullDate.getDate()).padStart(2, '0');
        const yyyy = fullDate.getFullYear();
        const date = `${dd}_${mm}_${yyyy}`;

        const fileName = `${this.localizedTexts.t('aumico_reports_cpmm_tasks').toString()}_${date}`;

        const tableTitle = `${this.localizedTexts.t('aumico_reports_cpmm_tasks').toString()} ${dd}.${mm}.${yyyy}`;

        let filterForExport: (TaskState | ExportTasksFilterState)[] = cloneDeep(this.tasksFilter?.taskStates);

        if (!filterForExport) {
            filterForExport = [TaskState.OPEN, TaskState.IN_PROGRESS, TaskState.IN_REVIEW, TaskState.DONE];
        }
        filterForExport.push(ExportTasksFilterState.INCLUDE_SECTION_NAMES);
        filterForExport.push(ExportTasksFilterState.INCLUDE_DUEDATES);

        this.workflowDocumentsProvider.dispatchExportTasksAsExcel(
            tableHeaders,
            dataToExport,
            fileName,
            filterForExport,
            tableTitle,
            this.currentOrganization,
        );
    }

    onActionClicked(actionId: string): void {
        if (actionId === 'STATUS_CHANGE') {
            this.openBulkEditStatus = true;
        } else if (actionId === 'ASSIGNEE_CHANGE') {
            this.openBulkEditAssignee = true;
        } else if (actionId === 'DUE_DATE_CHANGE') {
            this.openBulkEditDueDate = true;
        } else if (actionId === 'DELETE_TASKS') {
            this.openBulkDeleteConfirmationDialog = true;
        } else if (actionId === 'CLOSE_BULK_EDIT') {
            this.clearAllSelections();
        }
    }

    confirmDeleteBulkTasks(): void {
        this.openBulkDeleteConfirmationDialog = false;
        this.store.dispatch(
            TasksOverviewActions.bulkDeleteTasks({ taskIds: Array.from(this.selectedTasksForBulkActions) }),
        );
        this.clearAllSelections();
    }

    cancelDeleteBulkTasks(): void {
        // No action needed, just close the dialog
        this.openBulkDeleteConfirmationDialog = false;
    }

    onEditStatusConfirm(): void {
        if (this.bulkEditStatusControl.value) {
            this.openBulkEditStatus = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTasksForBulkActions),
                    updateTaskDto: {
                        taskState: this.bulkEditStatusControl.value.id,
                    },
                }),
            );
            this.bulkEditStatusControl.reset();
            this.clearAllSelections();
        }
    }

    onEditAssigneeConfirm(): void {
        if (this.bulkEditAssigneeControl.value) {
            this.openBulkEditAssignee = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTasksForBulkActions),
                    updateTaskDto: {
                        assignedTo: this.bulkEditAssigneeControl.value.id,
                    },
                }),
            );
            this.bulkEditAssigneeControl.reset();
            this.clearAllSelections();
        }
    }

    onEditDueDateConfirm(): void {
        if (this.bulkEditDueDateControl.value) {
            this.openBulkEditDueDate = false;
            this.store.dispatch(
                TasksOverviewActions.bulkUpdateTasks({
                    taskIds: Array.from(this.selectedTasksForBulkActions),
                    updateTaskDto: {
                        dueDate: this.bulkEditDueDateControl.value,
                    },
                }),
            );
            this.bulkEditDueDateControl.reset();
            this.clearAllSelections();
        }
    }

    // Selection logic methods
    clearAllSelections(): void {
        this.selectedTasksForBulkActions.clear();
        this.selectAllToggled = false;
    }

    // cleanup: Remove selections for tasks that are no longer visible after filtering
    private cleanupInvalidSelections(): void {
        const currentTaskIds = new Set<string>(this.tasksOverviewTableData.map((task) => task.id));
        const initialSize = this.selectedTasksForBulkActions.size;

        this.selectedTasksForBulkActions.forEach((taskId) => {
            if (!currentTaskIds.has(taskId)) {
                this.selectedTasksForBulkActions.delete(taskId);
            }
        });

        if (this.selectedTasksForBulkActions.size < initialSize) {
            this.selectAllToggled = false;
        }

        this.updateSelectAllState();
    }

    private updateSelectAllState(): void {
        if (this.tasksOverviewTableData.length === 0) {
            this.selectAllToggled = false;
            return;
        }

        const allSelected = this.tasksOverviewTableData.every((task) =>
            this.selectedTasksForBulkActions.has(task.id),
        );
        this.selectAllToggled = allSelected;
    }

    onToggleSelectAll(): void {
        if (this.selectAllToggled) {
            this.clearAllSelections();
        } else {
            this.selectedTasksForBulkActions.clear();
            this.tasksOverviewTableData.forEach((task) => this.selectedTasksForBulkActions.add(task.id));
            this.selectAllToggled = true;
        }
    }

    onToggleSelectTask(task: TaskMetaInformation): void {
        if (this.selectedTasksForBulkActions.has(task.id)) {
            this.selectedTasksForBulkActions.delete(task.id);
        } else {
            this.selectedTasksForBulkActions.add(task.id);
        }

        this.updateSelectAllState();
    }

    public bulkEditDueDate(m: Moment): void {
        // Build UTC midnight for that calendar day
        const year = m.year();
        const month = m.month(); // 0-based
        const dday = m.date();

        const asUtc = new Date(Date.UTC(year, month, dday, 0, 0, 0, 0));
        this.bulkEditDueDateControl.setValue(asUtc);
    }
}
